import type { ChatRoomType } from '../types/ChatMessageType';

const getChatRoomRecentTime = (chatRoom: ChatRoomType): number => {
  const recentDate = chatRoom.lastMessage?.sentAt ?? chatRoom.createdAt;
  const recentTime = recentDate ? new Date(recentDate).getTime() : 0;

  return Number.isNaN(recentTime) ? 0 : recentTime;
};

export const sortChatRoomsByRecentMessage = (chatRooms: ChatRoomType[]): ChatRoomType[] =>
  [...chatRooms].sort((a, b) => getChatRoomRecentTime(b) - getChatRoomRecentTime(a));
